const state = {
  data: null,
};

const getters = {
  profile: (state) => state.data,
};

const actions = {
  set({ commit }, data) {
    commit('set', data);
  },
  clear({ commit }) {
    commit('clear');
  },
};

const mutations = {
  set(state, data) {
    state.data = data;
  },
  clear(state) {
    state.data = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
